// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { ApiServiceError } from "../../../services/api/apiError";
import { apiService } from "../../../services/api/apiService";
import { requireToken, type DemoDataContext } from "../../../services/api/demoData";
import type { ConnectorCallbackConnector } from "../../../utils/connectorCallback";

const COMPLETE_PATHS: Record<ConnectorCallbackConnector, string> = {
  google: "/api/google-connections/complete",
  graph: "/api/graph-connections/complete",
  docusign: "/api/docusign-connections/complete",
};

interface ConnectionErrorBody {
  code?: unknown;
  error?: { code?: unknown } | null;
}

export async function completeConnection(
  connector: ConnectorCallbackConnector,
  callback: { code: string; state: string },
  context: DemoDataContext,
): Promise<void> {
  const token = requireToken(context);
  await apiService.requestJson<unknown, { code: string; state: string }>({
    path: COMPLETE_PATHS[connector],
    method: "POST",
    body: { code: callback.code, state: callback.state },
    token,
  });
}

export function connectionErrorCode(error: unknown): string | undefined {
  if (!(error instanceof ApiServiceError)) {
    return undefined;
  }
  try {
    const body = JSON.parse(error.responseBody) as ConnectionErrorBody | null;
    const code = body?.error?.code ?? body?.code;
    return typeof code === "string" ? code : undefined;
  } catch {
    return undefined;
  }
}
